/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { connect } from 'react-redux'

import { getProfile } from '@/apps/userconsole/reducers/profile'

import { inTrialBeforeCreateDeployment } from '../../../lib/trial'

import CreateStackDeployment from './CreateStackDeployment'

import type { ReduxState } from '@/types/redux'
import type { StateProps } from './CreateStackDeployment'

const mapStateToProps = (state: ReduxState): StateProps => {
  const profile = getProfile(state)
  const showTrialExperience = inTrialBeforeCreateDeployment({ profile })

  return {
    showTrialExperience,
  }
}

export default connect<StateProps>(mapStateToProps)(CreateStackDeployment)
